module.exports = __webpack_public_path__ + "img/21c2b49e6f9c76348503f0f90d3bc60.abdc61de.jpg";